export const INVOICES = {
  INVOICES: 'INVOICES',
  INVOICES_INVOICE_DETAILS: 'INVOICES_INVOICE_DETAILS',
  INVOICES_BUSINESS_YEARS: 'INVOICES_BUSINESS_YEARS',
  INVOICES_SERVICES_EXTENDED: 'INVOICES_SERVICES_EXTENDED',
  INVOICES_FISCALIZATION_F2_OPTIONS: 'INVOICES_FISCALIZATION_F2_OPTIONS',
  INVOICES_FISCALIZATION_REVIEW_INVOICE: 'INVOICES_FISCALIZATION_REVIEW_INVOICE',
  INVOICES_MARK_AS_PAID_INVOICE: 'INVOICES_MARK_AS_PAID_INVOICE',
  INVOICES_SEND_INVOICE_TO_EMAIL: 'INVOICES_SEND_INVOICE_TO_EMAIL',
  INVOICES_INVOICE_OPTIONS: 'INVOICES_INVOICE_OPTIONS',
  INVOICES_INVOICE_PAYMENT_METHODS: 'INVOICES_INVOICE_PAYMENT_METHODS',
};
